import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
@Component({
  selector: 'entity-status',
  templateUrl: './entity-status.component.html',
  styleUrls: ['./entity-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, AsyncPipe],
})
export class EntityStatusComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  hasKeyInObject(obj: any, key: string) {
    return Object.prototype.hasOwnProperty.call(obj, key);
  }
}
